import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { brazeInit, brazeScript } from 'analytics/braze';

import { removeScript } from 'helpers/DOM';
import { getLangCountryPrefix } from 'helpers/utils';

import { useApp, useCalculator, useExtra } from 'hooks/selectors';

import { DEFAULT_COUNTRY, DEFAULT_LANG } from '../../constants/Constants';
import Popup from '../common/Popup/Popup';
import PromoSpinner from '../no-auth/common/PromoSpinner/PromoSpinner';
import RouterCrossProductsLanding from '../no-auth/crossProducts/Landing/RouterCrossProductsLanding';
import Footer from '../no-auth/footer/Footer';
import HeaderFixed from '../no-auth/header-fixed/HeaderFixed';
import Banks from '../no-auth/landing/Banks';
import Benefits from '../no-auth/landing/Benefits';
import CalculatorSection from '../no-auth/landing/CalculatorSection';
import DeliveryMethodsLanding from '../no-auth/landing/DeliveryMethodsLanding';
import FAQ from '../no-auth/landing/Faq';
import Geo from '../no-auth/landing/Geo';
import Mastercard from '../no-auth/landing/Mastercard';
import MediaQuote from '../no-auth/landing/MediaQuote';
import MobileApp from '../no-auth/landing/MobileApp';
import Trustpilot from '../no-auth/landing/Trustpilot';
import MessageBodyService from '../utils/MessageBodyService';

const LandingPage = (props) => {
    const { availableBanks, noAuthFooter, showMastercardPromoBlock, showBanners: isBannerJava, newNoAuthMenu, deliveryMethodsPromo, geo } = useExtra();
    const { isShowNavModal, isShowModal, modalComponent } = useApp();
    const { countryMenu = {} } = useCalculator();

    const newMenuObject = newNoAuthMenu?.header;
    const isBannerStrapi = newNoAuthMenu?.isBanner;

    const lang = noAuthFooter?.language?.lang ?? DEFAULT_LANG;
    const country = noAuthFooter?.language?.country ?? DEFAULT_COUNTRY;

    useEffect(() => {
        const link = document.querySelector('link[rel="preload"]');
        if (link) {
            link.rel = 'stylesheet';
        }

        //Braze init
        if (__isBrowser__) {
            if (document.readyState === 'complete') {
                brazeInit();
            } else {
                window.addEventListener('load', brazeInit, { once: true });
            }
        }
        return () => removeScript(brazeScript);
    }, []);

    const data = props.data;
    let utmSource = data?.showSectionByUtmSource;

    return (
        <>
            <div id="modal-root" />
            {Array.isArray(newMenuObject) && newMenuObject.length > 0 && (
                <HeaderFixed
                    loading={props.loading}
                    isShowNavModal={isShowNavModal}
                    menuSection={props.stateOptions?.menuSection}
                    data={newMenuObject}
                    pageName={props.stateOptions?.pageName}
                    promoDarkPage={props.renderOptions?.promoDarkPage}
                    isLanding={true}
                />
            )}
            <div id="content" className="temp-spacing">
                <CalculatorSection isRequest={data.request} localeDependentURI={data.localeDependentURI} features={data.features} />
                {showMastercardPromoBlock ? <Mastercard data={data.mastercard} countryMenu={countryMenu} /> : ''}
                <Trustpilot data={data.trustpilot} />
                <MobileApp data={data.mobile} isRequest={data.request} />
                {utmSource && <Banks data={availableBanks} />}
                {utmSource && <DeliveryMethodsLanding data={deliveryMethodsPromo} countryTo={countryMenu?.countryTo} />}
                {utmSource && <Benefits data={data.benefits} />}
                {geo && (
                    <Geo
                        data={geo}
                        localeDependentURI={`${getLangCountryPrefix(lang, country)}${data.localeDependentURI}`}
                        countryFrom={countryMenu?.countryFrom}
                        countryTo={countryMenu?.countryTo}
                        isRequest={data.request}
                    />
                )}
                {utmSource && <FAQ data={data.faq} countryMenu={props?.countryMenu} isRequest={data.request} />}
                {(isBannerStrapi || isBannerJava) && <RouterCrossProductsLanding />}
                {utmSource && !data.request && <MediaQuote data={data.mediaQuote} />}
            </div>
            <PromoSpinner isEmptyText />
            {noAuthFooter && noAuthFooter.links && <Footer data={noAuthFooter} lang={lang} country={country} isLanding={true} isRequest={data.request} />}
            <MessageBodyService />
            <Popup />
            {isShowModal && modalComponent}
        </>
    );
};
LandingPage.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    stateOptions: PropTypes.object,
};

export default LandingPage;
